import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SedesService {
  private apiUrl = `${environment.apiUrl}/api/sedes`;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/json",
    });
  }

  getAll(): Observable<any> {
    return this.http.get(this.apiUrl, { withCredentials: true });
  }

  getById(id: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  }

  update(id: number | string, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  }

  inactivate(id: number | string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, {}, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  }

  activate(id: number | string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/activar`, {}, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  }

  remove(id: number | string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  }

  getSedesVias(): Observable<any> {
    return this.http.get(`${this.apiUrl}/vias`, { withCredentials: true });
  }
}